<label class="form-label">{{ label }}</label>
<select class="form-select" [(ngModel)]="value" [ngModelOptions]="{standalone: true}" (change)="onChange()">
  @for (choice of choices; track choice) {
    <option [ngValue]="choice.value">{{ choice.label }}</option>
  }
</select>
